import React from "react";
import "./TableLoader.css";

const TableLoader = ({ name = "Data", compact = false }) => (
  <div
    className={`harwin-table-loader${compact ? " compact" : ""}`}
    role="status"
    aria-live="polite"
  >
    <span className="harwin-table-loader__spinner" aria-hidden="true" />
    <span className="harwin-table-loader__text">
      Loading {name} Data... Please Wait
    </span>
  </div>
);

export default TableLoader;
